var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indemnity-description-container"},[(_vm.indemnity.amountForSeniority)?_c('typo',{attrs:{"name":"body-14-normal"},domProps:{"innerHTML":_vm._s(_vm.indemnity.amountForSeniority)}},[_vm._v(" "+_vm._s(_vm.indemnity.amountForSeniority)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }